module.exports = __webpack_public_path__ + "static/click-to-pay-c0fb3ae2974c149ebb9f43db926c2c09.png";